import { getMessages } from '../../../../../../../store/constants';

export const CHECKLIST_ITEM_ASSIGNER_REMOVED = getMessages().getText('activity_item_card__checklist_unassigned_other_end');
